var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotAvailable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 2,
    viewBox: "0 0 10 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 0.333008L5.66667 0.333008L9.66667 0.333008V1.66634H5.66667L4.33333 1.66634L0.333334 1.66634V0.333008H4.33333Z",
    fill: "#4E5459"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAvailable);
export default __webpack_public_path__ + "static/media/not-available.6e177dd2fa50e16f613888e690d76334.svg";
export { ForwardRef as ReactComponent };